import { render, staticRenderFns } from "./Extension.vue?vue&type=template&id=16d537a0&"
import script from "./Extension.vue?vue&type=script&lang=ts&"
export * from "./Extension.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports